export type NotifTone = 'info' | 'primary' | 'warning' | 'accent' | 'success' | 'danger';

export interface NotifItem {
  id: string;
  type: 'order' | 'driver' | 'alert' | 'rating' | 'package' | 'settlement';
  icon: string;
  tone: NotifTone;
  title: string;
  body: string;
  time: string;
  date: string;
  unread: boolean;
  actionLink?: string;
  actionLabel?: string;
}

export const notificationsFeed: NotifItem[] = [
  {
    id: 'n1',
    type: 'order',
    icon: 'ri-inbox-archive-line',
    tone: 'info',
    title: 'طلب جديد #98756',
    body: 'طلب جديد بانتظار القبول أو الرفض — أولوية مستعجل',
    time: 'قبل 4 دقائق',
    date: '2026-09-16',
    unread: true,
    actionLink: '/orders',
    actionLabel: 'عرض الطلب',
  },
  {
    id: 'n2',
    type: 'driver',
    icon: 'ri-e-bike-2-line',
    tone: 'primary',
    title: 'تأكيد مندوب',
    body: 'المندوب فهد العتيبي أكّد استلام الطلب #98744 من العميل',
    time: 'قبل 18 دقيقة',
    date: '2026-09-16',
    unread: true,
    actionLink: '/orders',
    actionLabel: 'عرض الطلب',
  },
  {
    id: 'n3',
    type: 'alert',
    icon: 'ri-alarm-warning-line',
    tone: 'warning',
    title: 'يحتاج تعيين يدوي',
    body: 'طلب #98745 بانتظار تعيين مندوب تسليم بعد انتهاء المدة المحددة',
    time: 'قبل 45 دقيقة',
    date: '2026-09-16',
    unread: true,
    actionLink: '/orders',
    actionLabel: 'عيّن مندوباً',
  },
  {
    id: 'n4',
    type: 'rating',
    icon: 'ri-star-line',
    tone: 'accent',
    title: 'تقييم جديد',
    body: 'نورة العتيبي قيّمت المغسلة بـ 5 نجوم — "خدمة ممتازة والتوصيل في الوقت"',
    time: 'قبل ساعتين',
    date: '2026-09-16',
    unread: false,
    actionLink: '/ratings',
    actionLabel: 'عرض التقييم',
  },
  {
    id: 'n5',
    type: 'package',
    icon: 'ri-box-3-line',
    tone: 'success',
    title: 'اشتراك في باقة',
    body: 'العميل عبدالله الشمري اشترك في باقة "غسيل وكوي الشهرية" — 30 قطعة',
    time: 'قبل 3 ساعات',
    date: '2026-09-16',
    unread: false,
    actionLink: '/packages',
    actionLabel: 'عرض الباقة',
  },
  {
    id: 'n6',
    type: 'order',
    icon: 'ri-inbox-archive-line',
    tone: 'info',
    title: 'طلب جديد #98751',
    body: 'طلب جديد من محمد السبيعي — 3 قطع غسيل وكوي عادي',
    time: 'قبل 5 ساعات',
    date: '2026-09-16',
    unread: false,
    actionLink: '/orders',
    actionLabel: 'عرض الطلب',
  },
  {
    id: 'n7',
    type: 'rating',
    icon: 'ri-star-line',
    tone: 'accent',
    title: 'تقييم جديد',
    body: 'محمد السبيعي قيّم المغسلة بـ 4 نجوم — "خدمة جيدة جداً"',
    time: 'أمس',
    date: '2026-09-15',
    unread: false,
    actionLink: '/ratings',
    actionLabel: 'عرض التقييم',
  },
  {
    id: 'n8',
    type: 'order',
    icon: 'ri-inbox-archive-line',
    tone: 'info',
    title: 'طلب جديد #98748',
    body: 'طلب جديد من سارة الحربي — 5 قطع كوي فقط مستعجل',
    time: 'أمس',
    date: '2026-09-15',
    unread: false,
    actionLink: '/orders',
    actionLabel: 'عرض الطلب',
  },
  {
    id: 'n9',
    type: 'package',
    icon: 'ri-box-3-line',
    tone: 'success',
    title: 'اشتراك في باقة',
    body: 'العميل ريم القحطاني اشتركت في باقة "غسيل الأسبوعية" — 10 قطع',
    time: 'أمس',
    date: '2026-09-15',
    unread: false,
    actionLink: '/packages',
    actionLabel: 'عرض الباقة',
  },
  {
    id: 'n10',
    type: 'settlement',
    icon: 'ri-bank-card-line',
    tone: 'success',
    title: 'تمت الموافقة على التسوية',
    body: 'تمت الموافقة على طلب تسويتك بمبلغ 3,240 ر.س وسيتم التحويل خلال يومي عمل',
    time: '14 سبتمبر 2026',
    date: '2026-09-14',
    unread: false,
    actionLink: '/finance',
    actionLabel: 'عرض التفاصيل',
  },
];